import React, {useState} from 'react';
import 'styles/pictures/display/ImageOverlay.css';
import {useSessionConfiguration} from 'util/SessionConfigurationContext';

const ImageOverlay = ({canShowPrevious, canShowNext, clicked}) => {
    const {isTouch} = useSessionConfiguration();

    const [isLeftHovered, setIsLeftHovered] = useState(false);
    const [isRightHovered, setIsRightHovered] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const [cooldown, setCooldown] = useState(false);

    if (!canShowPrevious && !canShowNext) return null;

    const arrowClicked = (direction, event) => {
        event?.stopPropagation();
        if (cooldown) {
            return;
        }
        setCooldown(true);
        clicked(direction);

        setTimeout(() => setCooldown(false), 250);
    };

    const mainContainerClicked = () => {
        if (!isTouch || cooldown) return;
        setShowAll(!showAll);
    };

    const hideArrows = cooldown;

    return (
        <div className="image-overlay-container" onClick={mainContainerClicked}>
            <div
                className="overlay-mouse-catcher left"
                onMouseEnter={() => setIsLeftHovered(true)}
                onMouseLeave={() => setIsLeftHovered(false)}
            >
                {!hideArrows && isLeftHovered && !isTouch && canShowPrevious && (
                    <div className="overlay-arrow" onClick={(e) => arrowClicked('L', e)}>
                        <span>&lt;</span>
                    </div>
                )}

                {!hideArrows && isTouch && canShowPrevious && showAll && (
                    <div className="overlay-arrow" onClick={(e) => arrowClicked('L', e)}>
                        <span>&lt;</span>
                    </div>
                )}
            </div>

            <div
                className="overlay-mouse-catcher right"
                onMouseEnter={() => setIsRightHovered(true)}
                onMouseLeave={() => setIsRightHovered(false)}
            >
                {!hideArrows && isRightHovered && !isTouch && canShowNext && (
                    <div className="overlay-arrow" onClick={(e) => arrowClicked('R', e)}>
                        <span>&gt;</span>
                    </div>
                )}

                {!hideArrows && isTouch && canShowNext && showAll && (
                    <div className="overlay-arrow" onClick={(e) => arrowClicked('R', e)}>
                        <span>&gt;</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImageOverlay;